<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Jadwal Hari Libur'">
          <template v-slot:toolbar>
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')" />
          </template>
          <template v-slot:body>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="code4.search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="code4.headers" :items="code4.desserts" :search="code4.search">
                <template v-slot:item.no="{ item ,index }">
                  {{ item.no }}
                </template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit')" />
                  <ButtonComponent colors="#EF4848" name="hapus"></ButtonComponent>
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>
        <b-modal ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger" id="modal"
          :title="`${statusModal} Hari Libur`">
          <b-form>
            <b-form-group label="Pilih Tanggal :">
              <b-form-input id="editTgl" type="date" required></b-form-input>
            </b-form-group>

            <b-form-group label="Keterangan :">
              <b-form-input id="editKet" type="text" required></b-form-input>
            </b-form-group>
          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"

export default {
  data() {
    return {
      code4: {
        search: "",
        headers: [
          { text: "No", align: "center", value: "no" },
          { text: "Tanggal", align: "center", value: "tgl" },
          { text: "Keterangan", align: "center", value: "ket" },
          { text: "Aksi", align: "center", value: "action" }
        ],
        desserts: [
          {
            no: 1,
            tgl: "12 Desember 2022",
            ket: "Hari Libur",
            action: "WHY"
          },
          {
            no: 2,
            tgl: "14 Desember 2022",
            ket: "Hari Libur",
            action: "WHY"
          },
          {
            no: 3,
            tgl: "16 Desember 2022",
            ket: "Hari Libur",
            action: "WHY"
          },
          {
            no: 4,
            tgl: "18 Desember 2022",
            ket: "Hari Libur",
            action: "WHY"
          },
          {
            no: 5,
            tgl: "20 Desember 2022",
            ket: "Hari Libur",
            action: "WHY"
          },
          {
            no: 6,
            tgl: "22 Desember 2022",
            ket: "Hari Libur",
            action: "WHY"
          }
        ]
      },
      statusModal: '',
      myValue: '',
    };
  },
  components: {
    KTCodePreview,
    // Select2,
    ButtonComponent,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Jadwal Hari Libur" }
    ]);


  },
  methods: {
    openModal(status) {
      this.statusModal = status
    }
  }
}
</script>